import { useEffect, useState } from 'react'
import { User } from '../../common/types'
import { isAccessTokenExpired, isRefreshTokenExpired, renewTokens } from '../../http-client'


interface UseAutoLoginParams {
  currentUser: User | null
  /** returns new access token */
  onSuccess?: (token: string) => void
}

/** Hook to handle automatic login if access token is expired but refresh token is valid */
export const useAutoLogin = ({ currentUser, onSuccess }: UseAutoLoginParams) => {
  const shouldAttemptAutoLogin = !currentUser && isAccessTokenExpired() && !isRefreshTokenExpired()

  const [isAutoLoginInProgress, setIsAutoLoginInProgress] = useState(shouldAttemptAutoLogin)

  useEffect(() => {
    if (!shouldAttemptAutoLogin) {
      setIsAutoLoginInProgress(false)
      return
    }

    let isMounted = true

    const attemptAutoLogin = async () => {
      try {
        //we call storeLogin and send send message to webview inside renewTokens.
        const renewResponse = await renewTokens()

        if (!isMounted || !renewResponse || !renewResponse.data) {
          return
        }

        onSuccess && onSuccess(renewResponse.data.accessToken)

      } catch (err) {
        const error: any = err;
        const message = error && error.message ? error.message : '';
        console.error(`Auto-login failed: ${message}`)
      } finally {
        if (isMounted) {
          setIsAutoLoginInProgress(false)
        }
      }
    }

    attemptAutoLogin()

    return () => {
      isMounted = false
    }
  }, [shouldAttemptAutoLogin, onSuccess])

  return { isAutoLoginInProgress }
}
